<template>
  <div
    class="d-flex flex-column cardWrapper mb-16 cardWrapper"
    :style="
      posicaoCard === 'esquerda'
        ? 'margin-left: 64px; justify-self: flex-start'
        : posicaoCard === 'centro'
        ? 'justify-self: center'
        : posicaoCard === 'direita'
        ? 'margin-right: 64px; justify-self: flex-end'
        : 'margin-left: 64px; justify-self: flex-start'
    "
  >
    <div
      class="d-flex align-center justify-center pa-2"
      :style="{
        background: backgroundCard,
        borderColor: corBorda,
        borderWidth: strokeWidth,
        borderStyle: 'solid',
      }"
    >
      <span id="timerContent" class="timeText" v-if="hasHours"
        >{{ time.split(":").at(0) }}:{{ time.split(":").at(1) }}:{{
          time.split(":").at(2)
        }}</span
      >
      <span id="timerContent" class="timeText" v-else
        >{{ time.split(":").at(1) }}:{{ time.split(":").at(2) }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cronometroData: Object,
    posicaoCard: String,
    corTexto: String,
    backgroundCard: String,
    corBorda: String,
    corTextoLastTenSeconds: String,
    corTextoCronometroZerado: String,
    showTimeoutText: Boolean,
  },
  components: {},
  data() {
    return {
      breakpoint: null,
      time: null,
      cachedData: null,
      isFinished: false,
      lastId: null,
      timerInterval: null,
      isCronometroPaused: false,
      resetTimer: false,
      strokeWidth: "5px",
    };
  },
  destroyed() {
    clearInterval(this.timerInterval);
  },
  computed: {
    hasHours() {
      if (this.cronometroData.tempo.split(":").at(0) === "00") {
        return false;
      }
      return true;
    },
    isProgressivo() {
      return (
        this.$store.state.producoes.selectedProducao &&
        this.$store.state.producoes.selectedProducao.sig_producao === "SPTV1"
      );
    },
  },
  created() {
    this.breakpoint = this.$vuetify.breakpoint.name;
    setInterval(this.checkIfCronometroIsPaused, 1000);
    setInterval(this.checkResetTimerFlag, 1000);
  },
  methods: {
    checkIfCronometroIsPaused() {
      if (localStorage.getItem("@socialcam/isCronometroPaused")) {
        this.isCronometroPaused = JSON.parse(
          localStorage.getItem("@socialcam/isCronometroPaused")
        );
      }
    },
    checkResetTimerFlag() {
      if (localStorage.getItem("@socialcam/resetTimer")) {
        this.resetTimer = JSON.parse(localStorage.getItem("@socialcam/resetTimer"));
      }
    },
    startTimer(timeString) {
      // Split the time string into hours, minutes, and seconds
      document.getElementById("timerContent").style.color = this.corTexto;
      let [hours, minutes, seconds] = timeString.split(":").map(Number);

      // Total duration configured for the cronômetro (the "end" value)
      const totalDuration = hours * 3600 + minutes * 60 + seconds;

      // Progressive mode counts UP from 0 to totalDuration; countdown counts
      // DOWN from totalDuration to 0. Only SPTV1 productions are progressive.
      const progressivo = this.isProgressivo;

      // totalSeconds always holds the value currently on screen
      let totalSeconds = progressivo ? 0 : totalDuration;

      // Function to update the timer display
      const updateTimer = () => {
        // Calculate hours, minutes, and seconds
        if (this.resetTimer) {
          document.getElementById("timerContent").style.color = this.corTexto;
          localStorage.setItem("@socialcam/resetTimer", false);
          this.resetTimer = false;
          totalSeconds = progressivo ? 0 : totalDuration;
        }
        let hrs = Math.floor(totalSeconds / 3600);
        let mins = Math.floor((totalSeconds % 3600) / 60);
        let secs = totalSeconds % 60;

        // Format the time as HH:MM:SS
        let formattedTime;
        if (hours > 0) {
          formattedTime = `${String(hrs).padStart(2, "0")}:${String(mins).padStart(
            2,
            "0"
          )}:${String(secs).padStart(2, "0")}`;
        } else {
          formattedTime = `${String(mins).padStart(2, "0")}:${String(secs).padStart(
            2,
            "0"
          )}`;
        }

        // Display the timer (you can update this to display in your HTML)
        // Update the timer display in the HTML
        document.getElementById("timerContent").textContent = formattedTime;

        // Advance the total seconds: up for progressive, down for countdown
        if (!this.isCronometroPaused) {
          totalSeconds = progressivo ? totalSeconds + 1 : totalSeconds - 1;
        }

        // Time still left before reaching the end, regardless of direction
        const remaining = progressivo ? totalDuration - totalSeconds : totalSeconds;

        // Highlight the last ten seconds before the end is reached
        if (remaining < 10 && remaining > 0) {
          document.getElementById(
            "timerContent"
          ).style.color = this.corTextoLastTenSeconds;
        }

        // Stop the timer when the end is reached (0 for countdown, totalDuration for progressive)
        if (remaining < 0) {
          clearInterval(this.timerInterval);
          document.getElementById(
            "timerContent"
          ).style.color = this.corTextoCronometroZerado;
          this.isFinished = false;
          if (this.showTimeoutText) {
            if (this.hasHours) {
              document.getElementById("timerContent").style.fontSize = "3rem";
            } else {
              document.getElementById("timerContent").style.fontSize = "2.5rem";
            }
            document.getElementById("timerContent").textContent = "TEMPO ESGOTADO";
          }
        }
      };

      // Start the timer and update every second
      this.timerInterval = setInterval(updateTimer, 1000);
    },
  },
  watch: {
    cronometroData(newVal) {
      if (this.lastId !== newVal.id) {
        clearInterval(this.timerInterval);
        this.time = this.cronometroData.tempo;
        document.getElementById("timerContent").style.color = this.corTexto;
        this.startTimer(this.cronometroData.tempo);
        this.lastId = newVal.id;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.timeText {
  font-size: 4.5rem;
  font-weight: bold;
}

.cardWrapper {
  min-width: 250px;
  max-width: 350px;
}
</style>